import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import Vue2Filters from 'vue2-filters'
import VueLazyload from 'vue-lazyload'
import VueMask from 'v-mask'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/sweet-alerts'
import '@/libs/toastification'
import '@/libs/vue-select'

// Axios Mock Adapter
import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(Vue2Filters)
Vue.use(VueLazyload)
Vue.use(VueMask)
Vue.use(VueLodash, { name: 'custom', lodash })

// Moment configuration
// eslint-disable-next-line import/no-extraneous-dependencies
const moment = require('moment')
// eslint-disable-next-line import/no-extraneous-dependencies
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment,
})

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.filter('currencyWhite', value => {
  if (value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
  }
  return 'Sin precio'
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
